<template>
  <div class="pages">
    <div class="content">
      <div class="search-contain">
        <div class="search">
          <div class="search-input">
            <el-input
                type="text"
                v-model="search"
                :placeholder="$t('main.pleaseEnter')"
                @keyup.enter.native="searchInput"
            ></el-input>
            <div class="search-icon">
              <i @click="searchInput" class="el-icon-search"></i>
            </div>
          </div>
          <p v-if="searchList">
            {{ $t("main.SearchResults") }}
            <el-tag
                v-for="(item,index) in searchList"
                :key="item"
                closable
                type="info"
                style="margin-right: 1.5%;"
                @close="handleClose(index)"
                @click="chooseTag(item)"
            >
              {{ item }}
            </el-tag>
          </p>
          <p v-if="nowSearch">
            {{ $t("main.SearchResultsLang",{keyword:nowSearch,num:total}) }}
          </p>
        </div>
      </div>
      <div>
        <a
            class="productList"
            v-for="(item, index) in productSearchGoods"
            :key="index"
            ref="content"

        >
          <div class="pleft" @click.stop="(event) => goToDetail(event, item)">
            <img
                class="cImg"
                :src="item.thumb || '/static/product/searchimg.png'"
            />
          </div>
          <div class="pright">
            <div class="ptop" @click.stop="(event) => goToDetail(event, item)"><span v-html="highlightKeywords(item.product_model)"></span>
              <span v-for="(itema,index2) in item.product_data" :key="index2">
              <span v-if="itema.value">
            _<span v-html="highlightKeywords(itema.value)"></span>
              </span>
          </span>
            </div>
            <div class="pbottom" @click.stop="(event) => goToDetail(event, item)">
              {{ item.description }}<span style="color:#635796;">{{ $t("main.view") }}</span>
            </div>
          </div>
        </a>
      </div>

      <div>
        <el-pagination
            layout="prev, pager, next"
            hide-on-single-page
            :total="total"
            :current-page="page"
            :page-size="limit"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getProductTpyeList, getSearchProductType, getProductInfo} from "@/api";
import {
  getProductTypeNavList
} from "@/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      page: 1,
      limit: 5,
      total: 0,
      productSearchGoods: [],
      isSearchType:0,
      searchList: [],
      search: "",
      nowSearch: "",
      productList: [],
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  created() {
    this.handleGetProduct(this.$route.query.keyword);
    this.search = this.$route.query.keyword.toUpperCase();
  },
  watch: {
    "$store.state.siteInfo": function(newV) {
      this.handleGetProduct(this.$route.query.keyword);
    }
  },
  methods: {
    //关键词高亮
    highlightKeywords(content) {
      var wordsearch = this.search.toUpperCase();
      const keywords = [wordsearch]; // 替换为你的关键词列表
      let highlightedContent = content;
      keywords.forEach(keyword => {
        const regExp = new RegExp(keyword, "gi");
        highlightedContent = highlightedContent.replace(regExp, "<span class=\"highlight\" style=\"color: #635796;\">" + keyword + "</span>");
      });
      return highlightedContent;
    },
    handleGetProductNav() {
      if (localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))) {
        this.productList = this.treeToArray(JSON.parse(localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))));
      }
    },
    goToDetail(event, item) {
      let params = {
        req: {
          id: item.type_id
        }
      };
      getProductInfo(params).then(res => {
        if(res.rsp.code === 0) {
          const toItem = res.data;
          if (this.isSearchType === 1) {
            this.$router.push({
              path: this.getRoutesPath('detail_product', toItem['identification'], toItem['id']),
              query: {
                keyword: item.product_model,
                anchor: "filter"
              }
            });
          } else {
            this.$router.push({
              path: this.getRoutesPath('detail_product', toItem['identification'], toItem['id']),
              query: {
                keyword: this.search,
                anchor: "filter"
              }
            });
          }
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    chooseTag(item) {
      this.handleGetProduct(item);
    },
    // 搜索
    searchInput() {
      this.handleGetProduct(this.search);
    },
    // 删除某条历史记录
    handleClose(index) {
      this.searchList.splice(index, 1);
    },
    handleGetProduct(value) {
      if (this.productList.length === 0) {
        this.handleGetProductNav();
      }
      let searchTypeIdsArr = [];
      const productTypeIdsArr = this.productList.filter(
          item => item.name.includes(value) || value === ''
      );
      productTypeIdsArr.forEach( item=>{
        searchTypeIdsArr.push(item['id']);
      });

      let params;
      if (productTypeIdsArr.length > 0) {
        this.isSearchType = 1;
        const searchTypeIdText = searchTypeIdsArr.join(',');
        params = {
          req: {
            model_id: "23",
            limit: this.limit,
            page: this.page,
            where: [
              {
                "condition": "1",
                "filed": "status",
                "expression": "="
              },
              {
                "condition": Cookies.get('siteInfo'),
                "filed": "site_id",
                "expression": "="
              },
              {
                condition: searchTypeIdText,
                filed: "type_id",
                expression: "IN"
              }
            ]
          }
        };
      } else {
        this.isSearchType = 0;
        params = {
          req: {
            type_id: 0,
            model_id: "23",
            limit: this.limit,
            page: this.page,
            where: [
              {
                "condition": "1",
                "filed": "status",
                "expression": "="
              },
              {
                "condition": Cookies.get('siteInfo'),
                "filed": "site_id",
                "expression": "="
              },
              {
                condition: "%" + (value || "") + "%",
                filed: "name|keywords|description|price|stock|declicks|clicks|comments|iscomment|delivery_has_stock|delivery_no_stock|product_model|product_data",
                expression: "LIKE"
              }
            ]
          }
        };
      }

      getProductTpyeList(params).then((res) => {
        if (res.rsp.code === 0) {
          this.productSearchGoods = res.data.list;
          this.total = res.data.total;
          this.nowSearch = value;
          if (value.trim() !== "") this.searchList.unshift(value);
          const set = new Set(this.searchList);
          this.searchList = Array.from(set);
        }
      });
    },
    handleSizeChange(val) {
      this.limit = val;
      this.handleGetProduct(this.search);
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      if (data) {
        auxiliary(data);
      }
      return res;
    },
    handleCurrentChange(newPage) {
      this.page = newPage;
      this.handleGetProduct(this.search);
    },
    arrayToTree(arr) {
      let res = [];
      let obj = {};
      arr.forEach(item => {
        item.id = item.id.toString();
        obj[item.id] = { ...item, label: item.name, children: [] };
      });
      arr.forEach(item => {
        item.id = item.id.toString();
        if (obj[item.pid]) {
          obj[item.pid].children.push(obj[item.id]);
        } else {
          res.push(obj[item.id]);
        }
      });
      return res;
    }
  }
};
</script>

<style scoped lang="less">
.highlight {
  background-color: #635796;
  font-weight: bold;
}

.pages {
  min-height: 100%;
  background-color: #fff;

  .cImg {
    width: 7rem;
    height: 3.5rem;
  }

  .search {
    margin: 0 auto;
    width: 80%;
  }

  .search-contain {
    width: 100%;
    margin-top: 5%;
  }

  .search-input {
    width: 80%;
    display: block;
  }

  .el-icon-search {
    position: relative;
    float: right;
    padding: 8px;
    top:-32px;
    cursor: pointer;
    z-index: 2000;
  }

  //搜索列表
  .productList {
    display: flex;
    flex-direction: row;
    align-items: stretch; // 垂直方向填充，时期高度相等
    margin-top: 20px;
    .pleft {
      cursor: pointer;
    }
    .ptop {
      cursor: pointer;
    }
    .pbottom {
      span {
        cursor: pointer;
      }
    }
    .pright {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-bottom: 1%;
      margin-left: 1%;
    }
  }
  /deep/ .el-input__icon {
    height: 32px;
    line-height: 32px;
    cursor: pointer;
  }

  /deep/ .el-pager li {
    background: #fff;
    margin: 0.1rem;
  }
  /deep/ .el-pagination {
    text-align: center;
  }
  /deep/ .el-pagination button:hover,.el-pagination button:focus,.el-pagination button:active {
    color: #635796;
  }
  /deep/ .el-pager li.active {
    background: #635796;
    color: #fff!important;
  }
  /deep/ .el-pager li:hover {
    background: #635796;
    color: #fff!important;
  }

  @media screen and (max-width: 1400px) {
    .content {
      padding: 0 2% 3.25rem;
    }
  }
  @media screen and (min-width: 1400px) {
    .content {
      padding: 0 10% 3.25rem;
    }
  }
  @media screen and (min-width: 1700px) {
    .content {
      padding: 0 15% 3.25rem;
    }
  }

}

</style>
